import React from "react";
import cookie from "js-cookie";
import Welcome from "../component/sections/Welcome";
import NotFounded from "../component/partials/other/NotFounded";
import userRoutes from "./user";
import campaignRoutes from "./campaigns";
import advertiseRoutes from "./advertise";
import financeRoutes from "./finance";
import ticketsRoutes from "./tickets";
import sitePublisher from "./site-publisher";
import actionCookie from "../helpers/action-cookie";
import ReportCampaign from "../component/sections/report/ReportCampaign";

const routes = [
  {
    path: "/",
    render: () => <Welcome />,
    exact: true,
  },
  ...userRoutes,
  ...campaignRoutes,
  ...advertiseRoutes,
  ...financeRoutes,
  ...sitePublisher,
  ...ticketsRoutes,
  {
    path: "/report/campaign",
    render: () => <ReportCampaign />,
    exact: true,
  },
  {
    path: "*",
    render: () => <NotFounded />,
    exact: true,
  },
];

routes.forEach((route) => {
  route.render = (function () {
    var cached_function = route.render;

    return function () {
      const result = cached_function.apply(this, arguments);
      cookie.set(
        actionCookie.PREVIOUS_PAGE_URL,
        cookie.get(actionCookie.CURRENT_PAGE_URL)
      );
      cookie.set(actionCookie.CURRENT_PAGE_URL, window.location.pathname);
      return result;
    };
  })();
});

export default routes;
